import script from "./LiveCasinoGamesWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveCasinoGamesWidget.vue?vue&type=script&setup=true&lang=js"

import "./LiveCasinoGamesWidget.vue?vue&type=style&index=0&id=0942b83e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0942b83e"]])

export default __exports__